import { PageHead } from "../ui";

/**
 * A page whose engine part has no screen yet (docs/specs/MODULE_NAVIGATION.md: no empty tabs). It names the page
 * and says in one or two lines what it will do.
 */
export function ComingSoon({ title, what, step }: { title: string; what: string; step?: string }) {
  return (
    <div className="page page-a coming-soon">
      <PageHead code={step} title={title} meta={<span className="chip">Coming soon</span>} />
      <p className="coming-soon-what">{what}</p>
    </div>
  );
}
